
import { Vue, Component } from 'vue-property-decorator'

import notif_service from '@/modules/notifications'
import user_service from '@/modules/user'
import { timestampPrepareDate } from '@/modules/tools'
import Loader from "@/components/loader/Loader.vue";

import b64DecodeUnicode from '@/lib/parseBase64';

@Component({
  components: {
    Loader
  }
})

export default class ListNotifications extends Vue {

  timestampPrepareDate: any = timestampPrepareDate;
  page: number = 0;
  loading: boolean = false;

  get notifications() {
    return notif_service.notifications
  }

  withTextNotifications(actions: any) {
    return actions ? actions.filter((item: any) => item.with_text) : []
  }
  withoutTextNotifications(actions: any) {
    return actions ? actions.filter((item: any) => !item.with_text) : []
  }

  decodeNotifyBody(str: string) {
    return b64DecodeUnicode(str);
  }

  goToRoute(address: string){

    if (address.indexOf('https://') > -1){
      
      return window.open(address);

    } 

    if (address[0] !== '/'){
      address = '/' + address;
    }

    this.$router.replace(address);
    user_service.toggleNoti(false);
    
  }

  closeNoti(){
    user_service.toggleNoti(false);  
  }

  jsonParse(json: string) {
    return JSON.parse(json)
  }
  openEmail(email: string, id: any) {
    notif_service.readEvents([id])
    window.open(`mailto:${email}`)
  }
  openPhone(phone: string, eventID: string) {
    user_service.sendMetric({payload: {eventID}, metricID: 'NOTIFY_CALL_BUTTON_CLICK'})
    window.open(`tel:${phone}`)
  }
  routerPush(link: string, id: any) {
    this.$router.push(link)
    notif_service.readEvents([id])
    this.$emit('closeNotifications')
  }
  getIcon(type: string) {
    if (type === 'TRACKINGIMG') {
      return 'far fa-envelope-open'
    }
    return 'fas fa-tasks'
  }

  async created() {

    this.loading = true;
    const result = await this.getNotifications();
    this.loading = false;
    console.log('result!!!!', result);
  }
  async mounted() {
    if (localStorage['lastNotificationScroll']) {
      let element = document.getElementById('list-notifications-id')
      element!.scrollTop = Number(localStorage['lastNotificationScroll'])
    }
  }
  async handleScroll() {
    const listElm = document.querySelector('#list-notifications-id');
    localStorage['lastNotificationScroll'] = listElm!.scrollTop
    if ((listElm!.scrollTop + listElm!.clientHeight) >= listElm!.scrollHeight - 10) {
      this.page += 1
      console.log('getNotifications!!');
      await this.getNotifications();
      // let ids: Array<any> = []
      // ids.push(...notif_service.last_page_notifications.map((item: any) => !item.read ? item.id : '').filter((i: any) => i))

      // setTimeout(() => {
      //   if (notif_service.last_page_notifications.length > 0) {
      //     notif_service.readEvents(ids)
      //     ids = []
      //   }
      // }, 3000);
    }
  }
  async getNotifications() {
    try {
      const response = await notif_service.getNotifications(this.page)
      this.$forceUpdate()
      console.log('getNotifications', response);

      return true;
    } catch (err) {

      console.log('err', err);

      this.$toasted.error('Something wrong! ', {
        duration: 4000
      });
      return false;

    }
  }

  async readEvent(ids: Array<number>) {
    try {
      const response = await notif_service.readEvent(ids);

      console.log('response', response);
    } catch (err) {

      console.log('err!', err)

      this.$toasted.error('Something wrong! ', {
        duration: 4000
      });
      // this.$toast.add({
      //   severity: "error",
      //   summary: "Something wrong!",
      //   detail: err,
      //   life: 4000,
      // })
    }
  }

  b64DecodeUnicode(str: string) {
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }
  beforeDestroy() {
    notif_service.destroyNotification()
  }
}
